import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { segmentedPillsStyles } from './segmented-pills.styles'

export type SegmentedPillItem<T extends string = string> = {
  key: T
  label: string
  icon?: React.ReactNode
}

export type SegmentedPillsProps<T extends string = string> = {
  items: SegmentedPillItem<T>[]
  value: T
  onChange: (value: T) => void
}

export function SegmentedPills<T extends string = string>({
  items,
  value,
  onChange,
}: SegmentedPillsProps<T>) {
  const theme = useTheme()

  return (
    <Box sx={segmentedPillsStyles.container(theme)}>
      {items.map((item) => {
        const isActive = value === item.key
        return (
          <Box
            key={item.key}
            onClick={() => onChange(item.key)}
            sx={segmentedPillsStyles.pill(isActive)}
          >
            {item.icon}
            <Typography variant="body2" sx={segmentedPillsStyles.pillLabel}>
              {item.label}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}
